export default __webpack_public_path__ + "static/media/cpp-octo-web.eded002a.svg";